"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _react["default"].createContext({
  color: {
    primary: null,
    secondary: null,
    danger: null,
    info: null,
    success: null,
    warning: null,
    background: null,
    backgroundAlternate: null,
    text: null
  },
  button: {
    allCaps: null,
    borderRadius: null,
    fontWeight: null
  },
  spinner: {
    color: null
  },
  checkbox: {
    borderRadius: null,
    color: {
      unchecked: null,
      checked: null
    }
  },
  loader: {
    color: null
  }
});

exports["default"] = _default;